// NOTE(DS migration, GOTU-3282): layout/text/color primitives migrated to @tempmee/react + @tempmee/tailwind.
// Non-primitive commonComponents here (DotsMenu/IconButton/Button/BackButton/CustomPortal/Checkbox/GridTable/EmptyScreen/Tooltip) have no DS equivalent yet and are kept
// intentionally — they belong to the separate form/action/shared-component migration categories.
import { motion } from 'framer-motion';
import moment from 'moment';
import { Tooltip } from '../../../../commonComponents/TooltipWrapper/TooltipWrapper';
import { UserProfession } from '../../../../enums/UserProfession';
import { OutlineChevronDownIcon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';
import { capitalizeEveryFirstLetter } from '../../../../utils/String';
import history from '../../../../browserHistory';

// ── inline styles ──────────────────────────────────────────────────────────
// Bespoke legacy markup styles; will be revisited with this component's
// form/action-component DS migration.

const styles = {
  title: {
    fontFamily: 'Nunito',
    color: colors.primary['500'],
    fontSize: 18,
    textAlign: 'center',
  },
  text: {
    fontFamily: 'Nunito',
    color: colors.neutral['500'],
    fontSize: 16,
    textAlign: 'center',
    textTransform: 'capitalize',
  },
};

export const ExpandableInviteCard = ({ job, isOpen, onToggle }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: colors.shades['0'],
      borderRadius: 8,
      boxShadow: '0px 1px 3px 1px rgba(0, 0, 0, 0.15)',
    }}
  >
    <button
      type="button"
      style={{
        height: '100%',
        all: 'unset',
        display: 'flex',
        justifyContent: 'space-between',
        cursor: 'pointer',
        padding: '32px 8px 32px 80px',
      }}
      onClick={(event) => {
        event.stopPropagation();
        onToggle();
      }}
    >
      <div
        style={{
          width: '100%',
          display: 'grid',
          gridTemplateColumns: '2fr 2fr 2fr 1fr',
          alignItems: 'center',
        }}
      >
        <button
          type="button"
          style={{
            all: 'unset',
            cursor: 'pointer',
            fontFamily: 'Nunito',
            color: colors.secondary['500'],
            fontSize: 18,
            fontWeight: 700,
            justifySelf: 'center',
          }}
          onClick={(event) => {
            event.stopPropagation();
            history.push(`/dashboard/job/${job?.id}`);
          }}
        >
          <Tooltip text="See Details">
            {moment(job?.localDate, 'MM/DD/YYYY').format('ddd, MMM DD, YYYY')}
          </Tooltip>
        </button>
        <span
          style={{
            fontFamily: 'Nunito',
            color: colors.neutral['600'],
            fontSize: 16,
            textAlign: 'center',
            marginLeft: 12,
          }}
        >
          {UserProfession.getName(job?.profession)}
        </span>
        <span
          style={{
            fontFamily: 'Nunito',
            color: colors.neutral['600'],
            fontSize: 16,
            textAlign: 'center',
            textTransform: 'lowercase',
            marginLeft: 12,
          }}
        >
          {job?.localStartTime} - {job?.localEndTime}
        </span>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <motion.div
            initial="closed"
            animate={isOpen ? 'open' : 'closed'}
            transition={{ duration: 0.4 }}
            variants={arrowVariants}
          >
            <OutlineChevronDownIcon size={24} color={colors.secondary[500]} />
          </motion.div>
        </div>
      </div>
    </button>
    <motion.div
      initial="closed"
      animate={isOpen ? 'open' : 'closed'}
      transition={{ duration: 0.5 }}
      style={{
        overflow: 'hidden',
        height: 'auto',
        backgroundColor: colors.shades['0'],
        borderBottomLeftRadius: 8,
        borderBottomRightRadius: 8,
      }}
      variants={collapsableVariants}
    >
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr',
          padding: '0 80px',
          margin: 'auto',
        }}
      >
        <b style={styles.title}>Professional</b>
        <b style={styles.title}>Sent on Date</b>
        <b style={styles.title}>Invite Status</b>

        <div
          style={{
            gridColumn: '1 / -1',
            height: 2,
            backgroundColor: colors.neutral['100'],
            margin: '8px 0',
          }}
        />

        {job?.favoriteInvites?.map((invite, index) => (
          <>
            <span style={styles.text}>
              {capitalizeEveryFirstLetter(invite?.professional?.fullName?.toLowerCase())}
            </span>
            <span style={styles.text}>{moment(invite?.createdAt).format('ddd, MMM DD, YYYY')}</span>
            <b style={styles.text}>{invite?.status === 'active' ? 'Pending' : invite?.status}</b>
            {job?.favoriteInvites?.length - 1 !== index && (
              <div
                style={{
                  gridColumn: '1 / -1',
                  height: 2,
                  backgroundColor: colors.neutral['100'],
                  margin: '12px 0',
                }}
              />
            )}
          </>
        ))}
      </div>
    </motion.div>
  </div>
);

const collapsableVariants = {
  open: {
    maxHeight: 2000,
    opacity: 1,
    paddingBottom: 32,
  },
  closed: {
    maxHeight: 0,
    opacity: 0,
  },
};

const arrowVariants = {
  open: {
    rotate: 180,
  },
  closed: {
    rotate: 0,
  },
};
